export const VALIDATE_ROUTE = '/validate';
export const DOCUMENT_ROUTE = '/document';
export const PHOTO_ROUTE = '/photo';
export const CONFIRMATION_ROUTE = '/confirmation';
export const CODES_ROUTE = '/codes';
export const LOGIN_ROUTE = '/login';
export const ADV_LOGIN_ROUTE = '/advlogin';
export const ADV_ID_ROUTE = '/advid';
export const ADV_ORDERS_ROUTE = '/advorders';
export const ADV_TEMPLATES_ROUTE = '/advtemplates';
export const ADV_FILES_ROUTE = '/advfiles';
export const NEW_PASSWORD_ROUTE='/newpassword';